type UUIDv4Format = `${string}-${string}-${string}-${string}-${string}`;
export type UUIDv4 = UUIDv4Format & { __brand: 'UUIDv4' };

export const generateUUIDv4 = (): UUIDv4 => crypto.randomUUID() as UUIDv4;
